import { gql } from '@apollo/client';

export const SEARCH_CREW_MEMBER_BY_TEXT = gql`
	query crewMembers($text: String) {
		crewMemberSearch(filter: { text: $text }, pagination: { page: 0, size: 50 }) {
			results {
				id
				fullName
				driverCard
				isActive
				currentHomeBase {
					city {
						name
					}
				}
				phone
			}
		}
	}
`;
